<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("stockout.条件筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="form-group mg-b-10">
          <div class="mg-b-10 form-group">
            <input
              type="text"
              :placeholder="$t('stockout.商品sku')"
              class="form-control form-control-dark tx-14"
              v-model="keySku"
              @keyup.enter="filtrate()"
            />
          </div>
        </div>
        <div class="form-group mg-b-10">
          <div class="mg-b-10 form-group">
            <select
              class="form-control form-control-dark pd-y-0"
              v-model="keyType"
              @change="filtrate"
            >
              <option value="">{{ $t("stockout.请选择登记类型") }}</option>
              <option
                v-for="(stock, index) in stockType"
                :key="index"
                :value="index"
              >
                {{ $t(stock) }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group mg-b-10">
          <div class="mg-b-10 form-group">
            <select
              class="form-control form-control-dark pd-y-0"
              @change="filtrate"
              v-model="keyStatus"
            >
              <option value="">{{ $t("stockout.全部状态") }}</option>
              <option
                v-for="(status, index) in statusArr"
                :key="index"
                :value="index"
              >
                {{ $t(status) }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group mg-b-10">
          <div class="mg-b-10 form-group">
            <select
              class="form-control form-control-dark pd-y-0"
              v-model="keyTime"
            >
              <option value="">{{ $t("stockout.请选择时间类型") }}</option>
              <option
                v-for="(time, index) in timeArr"
                :key="index"
                :value="index"
              >
                {{ $t(time) }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group mg-b-10">
          <div class="mg-b-10 form-group">
            <div class="datepicker-group">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
                </span>
                <input
                  v-model="dFrom"
                  data-id="datepicker-from"
                  type="text"
                  class="form-control-dark form-control fc-datepicker"
                  :placeholder="$t('stockout.起始日期')"
                />
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
                </span>
                <input
                  v-model="dTo"
                  data-id="datepicker-to"
                  type="text"
                  class="form-control form-control-dark fc-datepicker"
                  :placeholder="$t('stockout.截止日期')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary search btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate()"
    >
      {{ $t("stockout.筛 选") }}
    </button>
    <!-- todo3-缺货登记 -->
    <button
      @click="batchSearch('stockOut')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
export default {
  props: [
    "status",
    "key_type",
    "supplier_name",
    "supplier_contacts",
    "supplier_status",
    "supplier_id",
    "subUser",
    "subUserName",
    "subUserId",
    "dateFrom",
    "dateTo",
    "dateType",
    "sku",
  ],
  data() {
    return {
      keySupplierName: "",
      keySupplierId: "",
      keyContact: "",
      keyStatus: "",
      statusArr: arrDict.stockoutStatus,
      timeArr: arrDict.stockoutTime,
      keyTime: "",
      keySku: "",
      dFrom: "",
      dTo: "",
      keysubUserId: "",
      keysubUser: "",
      keyType: "",
      stockType: arrDict.stockType,
    };
  },
  watch: {
    key_type: function () {
      this.keyType = this.key_type;
    },
    sku: function () {
      this.keySku = this.sku;
    },
    subUserName: function () {
      this.keysubUser = this.subUserName;
    },
    subUserId: function () {
      this.keysubUserId = this.subUserId;
    },
    dateType: function () {
      this.keyTime = this.dateType;
    },
    dateFrom: function () {
      this.dFrom = this.dateFrom;
    },
    dateTo: function () {
      this.dTo = this.dateTo;
    },
    supplier_name: function () {
      this.keySupplierName = this.supplier_name;
    },
    supplier_contacts: function () {
      this.keyContact = this.supplier_contacts;
    },
    supplier_status: function () {
      this.keyStatus = this.supplier_status;
    },
    supplier_id: function () {
      this.keySupplierId = this.supplier_id;
    },
    dFrom: function () {
      $(".br-subleft [data-id=datepicker-from]")
        .parents(".datepicker-group")
        .find($("[data-id=datepicker-to]"))
        .datepicker("option", "minDate", this.dFrom);
    },
    dTo: function () {
      $(".br-subleft [data-id=datepicker-to]")
        .parents(".datepicker-group")
        .find($("[data-id=datepicker-from]"))
        .datepicker("option", "maxDate", this.dTo);
    },
    keyTime: function () {
      let vm = this;
      //日期控件初始化
      $(".br-subleft [data-id]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            if ($(this).data("id") == "datepicker-from") {
              $(this)
                .parents(".datepicker-group")
                .find($("[data-id=datepicker-to]"))
                .datepicker("option", "minDate", selectedDate);
            } else if ($(this).data("id") == "datepicker-to") {
              $(this)
                .parents(".datepicker-group")
                .find($("[data-id=datepicker-from]"))
                .datepicker("option", "maxDate", selectedDate);
            }
          },
          onSelect: (selectedDate) => {
            if ($(this).data("id") == "datepicker-from") {
              vm.dFrom = selectedDate;
            } else if ($(this).data("id") == "datepicker-to") {
              vm.dTo = selectedDate;
            }
          },
        });
      });
    },
  },
  components: {},
  updated() {
    // custom scrollbar style
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    sideChangeStatus() {
      //边栏状态改变
      this.$emit("changeStatus");
    },
    changeName(name) {
      this.keySupplierName = name;
    },
    filtrateName(name, id) {
      if (!id || id == "e999") {
        ShowTip(this.$t("stockout.没有匹配的供应商"), "danger");
        this.keySupplierName = "";
        this.keySupplierId = "";
      } else {
        //清空按联系人
        this.keyContact = "";
        this.keySupplierName = name;
        this.keySupplierId = id;
      }
      this.filtrate();
    },
    changeContact(contact) {
      this.keyContact = contact;
    },
    filtrateContact(contact, id) {
      if (!id || id == "e999") {
        ShowTip(this.$t("stockout.没有匹配的供应商"), "danger");
        this.keyContact = "";
        this.keySupplierId = "";
      } else {
        //清空按供应商名
        this.keySupplierName = "";
        this.keyContact = contact;
        this.keySupplierId = id;
      }
      this.filtrate();
    },
    filtrateSubUser(id, name) {
      this.keysubUserId = id;
      this.keysubUser = name;
      this.filtrate();
    },
    filtrate() {
      if (!this.keySupplierId) this.keySupplierName = this.keyContact = "";
      this.$emit(
        "filtrate",
        this.keyType,
        this.keySupplierName,
        this.keySupplierId,
        this.keyContact,
        this.keyStatus,
        this.keysubUserId,
        this.keysubUser,
        this.keySku,
        this.keyTime,
        this.dFrom,
        this.dTo
      );
    },
  },
};
</script>
